(() => {
  if (window.allSixRefreshLoaded) return;
  window.allSixRefreshLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');

  const parallaxMedia = Array.from(
    document.querySelectorAll(
      '.banner__media img, .image-with-text__media img, .slideshow__media img'
    )
  );

  parallaxMedia.forEach((image) => image.classList.add('as-parallax-media'));

  let ticking = false;

  const updateParallax = () => {
    ticking = false;

    if (reduceMotion.matches || !desktop.matches) {
      parallaxMedia.forEach((image) => image.style.removeProperty('--as-parallax-y'));
      return;
    }

    parallaxMedia.forEach((image) => {
      const frame = image.parentElement;
      if (!frame) return;
      const bounds = frame.getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;

      const centerOffset = bounds.top + bounds.height / 2 - window.innerHeight / 2;
      const movement = Math.max(-28, Math.min(28, centerOffset * -0.045));
      image.style.setProperty('--as-parallax-y', `${movement.toFixed(2)}px`);
    });
  };

  const requestParallax = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  };

  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax);
  reduceMotion.addEventListener('change', requestParallax);
  desktop.addEventListener('change', requestParallax);
  requestParallax();
})();
